<template>
  <div id="reset-password-page">
    <div id="reset-password-wrapper">
      <div class="screen-text verifying" v-if="isVerifying">Loading...</div>

      <v-card class="screen-text verify-failed" v-if="status === 'verify-failed'">
        <v-card-title>Verify code is invalid</v-card-title>
        <v-card-text>Your security token is not valid or expired.</v-card-text>
      </v-card>

      <form
        class="reset-password-form"
        v-if="status === 'verify-success'"
        @submit.prevent="onSubmit"
      >
        <v-card>
          <v-card-title>Reset Password</v-card-title>
          <v-card-text>
            <div class="control-group">
              <label class="form-control-label">New Password</label>
              <input type="password" v-model="password" required />
              <input type="submit" value="Reset Password" class="btn btn-primary" />
            </div>
            <div
              class="text-danger"
              v-if="!isValidPassword"
            >Your password must contains at least 8 characters and combine with at least 1 uppercase character, number and special character.</div>
          </v-card-text>
        </v-card>
      </form>

      <v-card class="screen-text reset-success" v-if="status === 'success'">
        <v-card-title>Reset Password Successfully</v-card-title>
        <v-card-text>Your password has been resetted. You can begin to sign in with your new password right now.</v-card-text>
        <v-carc-actions>
          <v-btn text color="green" to="/">OK</v-btn>
        </v-carc-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVerifying: false,
      isValidPassword: true,
      status: "initial",
      password: ""
    };
  },
  mounted() {
    if (!this.$route.query.code) {
      this.$router.push("/");
      return;
    }

    this.verifyToken();
  },
  methods: {
    verifyToken() {
      this.isVerifying = true;
      this.$repo.user
        .verifyResetPasswordCode(this.$route.query.code)
        .then(result => {
          this.isVerifying = false;
          this.status = result === true ? "verify-success" : "verify-failed";
        })
        .catch(_ => {
          this.isVerifying = false;
          this.status = "verify-failed";
        });
    },
    onSubmit() {
      this.isValidPassword = this.$repo.user.testPassword(this.password);
      if (!this.isValidPassword) return;

      this.$repo.user
        .resetPassword(this.password, this.$route.query.code)
        .then(() => {
          this.password = "";
          this.status = "success";
        })
        .catch(error => {
          console.error(error);
          this.$toasted.show("Something went wrong.", {
            type: "error",
            duration: 3000,
            position: "bottom-right"
          });
        });
    }
  }
};
</script>

<style scoped lang="scss">
#reset-password-page {
  position: relative;
  width: 100vw;
  height: 100vh;

  #reset-password-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  h1 {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .screen-text {
    font-size: 2em;
  }

  .control-group {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > input {
      margin-left: 10px;
    }

    label {
      margin: 0;
    }
  }

  .text-danger {
    max-width: 400px;
    margin-top: 1em;
    text-align: center;
  }
}
</style>